export default "/institutions/agora.svg";